import { createFileRoute } from '@tanstack/react-router';
import { FlowUpgradePage, FLOW_UPGRADE_BY_KEY } from '@/components/FlowUpgrades';

export const Route = createFileRoute('/_authenticated/upgrade/conversations')({
  component: RouteComponent,
});

function RouteComponent() {
  return <FlowUpgradePage content={FLOW_UPGRADE_BY_KEY.conversations} />;
}
